export const OrderStatus: { [key: string]: any }  = {
    waiting: 'Непотвърдена',
    waiting_payment : 'Непотвърдена',
    completed : 'Завършена',
    cancelled : 'Отказана',
    confirmed : 'Потвърдена',
    dispatched : 'Изпълнена',
    in_delivery : 'В процес',
    delivered  : 'Доставена ',
    returned: 'Върнати',
    printed: 'Подготвена',
    requested: 'Заявена към куриер',
    returnedConfirmed: 'Върната: Одобрена',
    returnedCancelled: 'Върната: Отказана',
    returnedWaiting: 'Обработва се'
};
